module.exports = __webpack_public_path__ + "static/media/Visa.ae41f7d6.svg";